/**
 * Card component for displaying content
 */

import { forwardRef } from 'react';
import { motion, HTMLMotionProps } from 'framer-motion';

interface CardProps extends Omit<HTMLMotionProps<'div'>, 'whileHover'> {
  hover?: boolean;
  children: React.ReactNode;
}

export const Card = forwardRef<HTMLDivElement, CardProps>(
  ({ children, hover = true, className = '', style = {}, ...props }, ref) => {
    return (
      <motion.div
        ref={ref}
        className={`card-magreen ${hover ? 'hover-lift' : ''} ${className}`}
        style={style}
        whileHover={hover ? { y: -8 } : undefined}
        {...props}
      >
        {children}
      </motion.div>
    );
  }
);

Card.displayName = 'Card';
